import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let ToasterComp;

class Toaster extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: ToasterComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/lyte-components/toaster-comp" */
      "../../../components/javascript/lyte-components/toaster-comp"
    ).then(function(res) {
      ToasterComp = res.ToasterComp;
    }));

    
;
  }
}

export { Toaster };
